import type { OsasTreatmentChoiceCustomControlData } from '@common/validation/customControls/osas/osasTreatmentChoice/types';
import {
    osasYesChosenTreatmentInitialData,
    therapielandProgramSelectionInitialData,
} from '../osasConsult/osasConsultData';

export const initialData: OsasTreatmentChoiceCustomControlData = {
    ...therapielandProgramSelectionInitialData,
    ...osasYesChosenTreatmentInitialData,
    remarkOther: null,
    taskForPoliclinic: null,
    treatmentToBreak: [],
    treatmentToBreakRemark: null,
};
